import React from "react";
import Modal, { ModalBody } from "../Modal";
import { FilterChip } from "../primitives";
import { categoryEmoji } from "../../../../utils/categoryEmoji";

/** Mockup `catsheet`: category chips in a narrow modal. selected = category object or null (All). */
export default function CategorySheet({ categories, selected, onPick, onClose }) {
  return (
    <Modal title="Categories" size="narrow" onClose={onClose} testId="home.filters">
      <ModalBody>
        <div className="row wrap" style={{ flexWrap: "wrap" }}>
          <FilterChip on={!selected} data-testid="home.filters.all" onClick={() => onPick(null)}>All</FilterChip>
          {categories.map((c) => (
            <FilterChip key={c.id} on={selected?.id === c.id} data-testid={`home.filters.${c.id}`} onClick={() => onPick(c)}>
              {categoryEmoji(c.name) ? `${categoryEmoji(c.name)} ` : ""}{c.name}
            </FilterChip>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
}
